import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import find from 'lodash/find';
import get from 'lodash/get';
import values from 'lodash/values';
import Moment from 'moment';
import { actions } from 'react-redux-form';
import _ from 'lodash';
import DisclaimerViews from './DisclaimerViews';
import ErrorInvesting, { INVEST_ERROR_TYPE } from './ErrorInvesting';
import InvestmentConfirmation from './InvestmentViews/InvestmentConfirmation';
import ReviewDisclosureDocuments from './InvestmentViews/ReviewDisclosureDocuments';
import SecurityDeliveryInformation from './InvestmentViews/SecurityDeliveryInformation';
import ReviewOrder from './InvestmentViews/ReviewOrder';
import SelectInvestmentAmount from './InvestmentViews/SelectInvestmentAmount';
import redirectByFormValidation from './redirectByFormValidation';
import { placeExternalOrder } from '../../actions/investment';
import { offeringCategory } from '../../helpers/mappings';
import {
  externalOfferOrderDeliveryPath,
} from '../Forms/Schemas/baseRrf';
import {
  navigate,
  transferFundsDeposit,
} from '../../actions';

import {
  fetchUserAccreditationStatus,
} from '../../actions/user';

import {
  addNotification,
} from '../../actions/notifications';
import { errorCodes } from '../TransferFunds/TransferReview';


export const routes = [
  { step: 'Amount', path: 'amount', Comp: SelectInvestmentAmount },
  { step: 'Disclosures', path: 'disclosures', Comp: ReviewDisclosureDocuments },
  { step: 'Delivery', path: 'delivery', Comp: SecurityDeliveryInformation },
  { step: 'Review', path: 'review-order', Comp: ReviewOrder },
];

class OfferOrder extends React.Component {
  constructor(props) {
    super(props);
    // const route = this.getRoute(props);
    let offer = find(props.offerings, { id: this.props.match.params.offerId });

    if (offer) {
      offer = {
        ...offer,
        categoryName: values(offeringCategory).find(item => item.value === offer.category).label,
      };
    }

    this.state = {
      offer: (offer || {}),
      isSubmitting: false,
    };
  }
  componentDidMount() {
    if (!get(this.props.userAccreditationStatus, 'parentVerifyLevel')) {
      this.props.fetchUserAccreditationStatus();
    }
  }

  onNext = async () => {
    const {
      match,
    } = this.props;

    const nextRoute = this.getNextRoute();
    if (nextRoute) {
      if (nextRoute.path === 'delivery') {
        const { offer } = this.state;
        if (!_.isEmpty(offer.securityDeliveryInformationOptions)
          && !_.isEmpty(offer.securityDeliveryInformationOptions.options) &&
          offer.securityDeliveryInformationOptions.options.length > 0) {
          let pickedOption = _.find(offer.securityDeliveryInformationOptions.options, { initialValue: true });
          if (_.isEmpty(pickedOption)) {
            // eslint-disable-next-line prefer-destructuring
            pickedOption = offer.securityDeliveryInformationOptions.options[0];
          }
          this.props.setSecurityDeliveryMode(pickedOption.optionLabel.replace('<tooltip>', '').replace('</tooltip>', ''));
        }
      }
      this.props.navigate(`${match.url}/${nextRoute.path}`);
    } else if (!this.state.isSubmitting) {
      try {
        // this.setState({ isSubmitting: true });
        await this.props.submitOrder(match.params.offerId);
        this.props.navigate(`${match.url}/confirmation`);
        // this.setState({ isSubmitting: false });
      } catch (err) {
        if (err.res) {
          const { errors } = await err.res.json();
          if (errors && errors.length && errors.length > 0) {
            errors.forEach(error => (
              this.props.addNotification(error.message || errorCodes[error.errorCode])
            ));
          } else {
            this.props.addNotification(`Error response from server: ${
              (errors && errors.validationErrors && JSON.stringify(errors.validationErrors, null, 2))}`);
          }
        } else {
          this.props.navigate(`${match.url}/error`);
        }
        // this.setState({ isSubmitting: false });
      }
    }
  }

  getRouteIndex = (props) => {
    const { match, location } = props || this.props;
    const curPath = location.pathname.replace(new RegExp(`^${match.url}/`), '');
    return routes.findIndex(route => route.path === curPath);
  }

  getRoute = props => routes[this.getRouteIndex(props)];
  getNextRoute = props => routes[this.getRouteIndex(props) + 1];

  render() {
    const {
      match,
      location,
      userAccreditationStatus,
    } = this.props;
    if (!this.props.user || !this.props.user.id) {
      return (
        <Redirect to="/login" />
      );
    }

    // Accredited investors are not required to meet the 10% maximum investment
    //  for Reg A+ offers
    const accredStatus = get(userAccreditationStatus, 'parentVerifyLevel');
    const accredExpDate = get(userAccreditationStatus, 'parentVerifyLevelExpirationDate');
    const today = new Moment();
    const isAccredited = (accredStatus && accredStatus.toLowerCase() === 'a'
      && accredExpDate && Moment(today).isBefore(Moment(accredExpDate)));

    // Only Reg A+ Offers are subject to the non-accredited 10% max
    const isRegAPlus = get(this.state, 'offer.offerType', '')
      .toLowerCase().replace(/\s+/g, '') === 'rega+';

    const hasMaximumInvest = !isAccredited && isRegAPlus;
    const { isConditional } = this.state.offer;

    // redirect to page based on form validation state
    const formRedirect = redirectByFormValidation(
      location.pathname,
      this.props.externalOfferOrderForm,
      this.state.offer, // validation must be on a offer specific basis
      this.props.cashBalance,
      this.props.pendingTransfers,
      this.props.restrictions,
    );
    if (formRedirect) {
      return formRedirect;
    }

    return (
      <Switch>
        <Route
          path={`${match.url}/restricted-person`}
          render={() => (
            <DisclaimerViews
              view="restrictedPerson"
              offerId={match.params.offerId}
            />)}
        />
        <Route
          path={`${match.url}/other-factors`}
          render={() => (
            <DisclaimerViews
              view="otherFactors"
              offerId={match.params.offerId}
            />)}
        />
        <Route
          path={`${match.url}/terms-and-conditions`}
          render={() => (
            <DisclaimerViews
              view="termsAndConditions"
              offerId={match.params.offerId}
            />)}
        />
        <Route
          path={`${match.url}/error`}
          render={() => (
            <ErrorInvesting
              offer={this.state.offer}
              errorType={INVEST_ERROR_TYPE.GENERAL}
              accountNumber={this.props.currentAccount}
            />)}
        />
        <Route
          path={`${match.url}/account-restriction`}
          render={() => (
            <ErrorInvesting
              offer={this.state.offer}
              errorType={INVEST_ERROR_TYPE.ACCOUNT_RESTRICTED}
              accountNumber={this.props.currentAccount}
            />)}
        />
        {routes.map(({ path, Comp }) => (
          <Route
            exact
            key={path}
            path={`${match.url}/${path}`}
            render={() => (
              <Comp
                isConditional={isConditional}
                externalOfferOrderForm={this.props.externalOfferOrderForm}
                hasMaximumInvest={hasMaximumInvest}
                offer={this.state.offer}
                onNext={this.onNext}
              />
            )}
          />
        ))}
        <Route
          path={`${match.url}/confirmation`}
          render={() => (
            <InvestmentConfirmation
              offer={this.state.offer}
              history={this.props.history}
            />)}
        />
        <Redirect to={`${match.url}/amount`} />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  offerings: state.offerings.data,
  user: state.user.data,
  currentAccount: state.currentAccount,
  externalOfferOrderForm: state.externalOfferOrderForm,
  investmentsByOffer: state.investmentsByOffer,
  cashBalance: get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceAvailableForT1Trades'),
  pendingTransfers: Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.pendingTransfersAvailableForOfferings')),
  restrictions: get(state, `accountRestrictionsByAccount[${state.currentAccount}].data`, []),
  userAccreditationStatus: state.userAccreditationStatus,
});

const mapDispatchToProps = dispatch => ({
  navigate: (...args) => (dispatch(navigate(...args))),
  submitOrder: offerId => (dispatch(placeExternalOrder(offerId))),
  submitTransfer: (accountNumber, transferInfo) => (
    dispatch(transferFundsDeposit(accountNumber, transferInfo.transferAmount, transferInfo.from))
  ),
  addNotification: (...args) => (dispatch(addNotification(...args))),
  fetchUserAccreditationStatus: (...args) => (dispatch(fetchUserAccreditationStatus(...args))),
  setSecurityDeliveryMode: async mode => (dispatch(actions.change(`${externalOfferOrderDeliveryPath}.delivery`, mode))),
});

export default connect(mapStateToProps, mapDispatchToProps)(OfferOrder);



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/index.js